import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacategory,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity, Text, I18nManager, BackHandler,
} from "react-native";

const {width: SCREEN_WIDTH} = Dimensions.get("window");
import {moderateScale} from "../../../../tools/Scaling";
import Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";


const WINDOW_WIDTH = Dimensions.get('window').width;
const BASE_PADDING = 10;

//import Orientation from "react-native-orientation";
import store from "../../../../redux/store/index";

const theme = {
    title: '#FFF',
    more: '#446984',
    center: '#7B8F99',
    fullscreen: '#446984',
    volume: '#A5957B',
    scrubberThumb: '#234458',
    scrubberBar: '#DBD5C7',
    seconds: '#DBD5C7',
    duration: '#DBD5C7',
    progress: '#446984',
    loading: '#DBD5C7'
}
import {Tools} from "../../../../tools/Tools";
import i18n from "../../../../I18n/i18n";
import HMListItemTitle from "../../../../customviews/HMListItemTitle";

import {typeExport} from "../../../../redux/store/type";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMVideo from "../../../../customviews/video/HMVideo";
import Popup from "../../../../tools/mapLink/components/Popup";
import HMIcon from "../../../../customviews/HMIcon";
import HMSwiper from "../../../../customviews/swiper/HMSwiper";
import HMModal from "../../../../customviews/modal/HMModal";
import HMMap from "../../../../customviews/map/HMMap";
import HMImageView from "../../../../customviews/HMImageView";
import HMVoicePlayer from "../../../../customviews/voice/HMVoicePlayer";

import HMFlatList from "../../../../customviews/HMFlatList";
import HMBottomBarItemSatiaOperator from "../../../../customviews/bottombarItem/HMBottomBarItemSatiaOperator";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import * as NavigationService from "../../../../redux/NavigationService";

var container = null;
var sound = null;

export default class DetailsTaskOperationSatiaScreen extends Component {
    _onViewableItemsChanged = ({viewableItems, changed}) => {
    };

    _viewabilityConfig = {
        itemVisiblePercentThreshold: 50
    };

    constructor(props) {
        super(props);
        container = this;

        let {files, video, audio, image} = props.route.params.item ? props.route.params.item : {};

        let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')).file)
        let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')).file)
        let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')).file)
        let sliderWidth = 1;
        let itemWidth = 1;
        let slideHeight = 1;
        let widthOriginal = Platform.OS === "web" ? 1 : typeExport._WIDTH;

        if (Platform.OS === "web") {
            let viewportWidth = document.body.clientWidth;
            let viewportHeight = document.body.clientHeight;
            widthOriginal = document.body.clientWidth;

            slideHeight = viewportHeight * 0.35;


            sliderWidth = viewportWidth;
        }
        // if (!this.state.arrayDate || this.state.arrayDate.length === 0) {
        //     //   dateFinal = itemLastWork.date_split;
        //     this.state.arrayDate.push(itemLastWork)
        // }
        // else if (!resultDataSplit) {
        //     //  dateFinal = itemLastWork.date_split;
        //     this.state.arrayDate.push(itemLastWork)
        // }

        // let arrr = [];
        // let lllll = props.route.params.item.lastWork;
        // for (let i = 0; i < lllll.length; i++) {
        //     let resultDataSplit = this.state.arrayDate.find(obj => obj.date_split = lllll[i].date_split);
        //     if (resultDataSplit) {
        //
        //     }
        //     else {
        //
        //     }
        //
        // }
        let res_item = props.route.params.item;
        // if (res_item)
        //     res_item.lastWork = this.addFlagDate(res_item.lastWork)
        this.state = {
            focusedAnim: new Animated.Value(1),

            widthOriginal: widthOriginal,
            indexSelectVoice: -1,
            itemWidth: itemWidth,
            sliderWidth: sliderWidth,
            slideHeight: slideHeight,
            slider1ActiveSlide: 0,
            modalHeight: 0,
            isFull: false,

            FinalList: [],


            listVideo: [],
            listImage: [],
            listVoice: [],
            listOthers: [],

            // listOthersTasks: [],


            ShowImage: false,
            ShowVideo: false,
            visibleModal: '',
            playSeconds: 0.0,
            playState: 'playing',

            index: 0,
            setIndex: 0,
            routes: [
                {key: 'first', title: 'وظیفه'},
                {key: 'second', title: i18n.t('constant.Information')},
                {key: 'third', title: i18n.t('constant.MessageCirculation')},
            ],

            pathAudio: checkAudio,
            pathVideo: checkVideo,
            more: false,
            largeMap: false,
            arrayDate: [],
            stateItemExtraFirst: res_item,
            stateItemExtra: res_item,
            alaki: false,


            listName: [],
            isLoadingCompress: false,
        };


        if (files)
            for (let i = 0; i < files.length; i++) {
                let f = String(files[i].type);

                if (f.search('audio/') >= 0)
                    this.state.listVoice.push(files[i])

                else if (f.search('image/') >= 0)
                    this.state.listImage.push(files[i])

                else if (f.search('video/') >= 0)
                    this.state.listVideo.push(files[i])
                else {

                    this.state.listOthers.push(files[i])

                }

            }


        this.onFullScreen = this.onFullScreen.bind(this);// you should bind this to the method that call the props

        // if (res_item.Serial_resend && res_item.Status_resend == 0)
        //     this.getData()
        // else if (res_item.Serial && res_item.Status == 0)


    }

    addFlagDate(data) {
        if (data && data.length > 0) {
            //  alert("fhfh")
            let result_lastWork = data;
            let arraySearch = [];
            let start = null;
            let end = null;
            let count = 0;
            for (let i = 0; i < result_lastWork.length; i++) {
                let resultDataSplit = arraySearch.find(obj => {
                    //  return obj.date_split === result_lastWork[i].date_split
                    return obj.date_split === result_lastWork[i].date_split
                });

                //
                if (start && count > 0 && !resultDataSplit) {
                    count = 0;
                    end = true;
                    start = null;
                    result_lastWork[i].flagDate = true;
                }
                if (resultDataSplit) {
                    count = +1;

                }
                else {
                    end = null;
                    arraySearch.push(result_lastWork[i])
                    start = result_lastWork[i].date_split;
                    count = 1;
                }

                if (i === result_lastWork.length - 1 && !end) {
                    result_lastWork[i].flagDate = true;
                }
                //if (key === action.index) {
                // if (!resultDataSplit) {
                //     //console.log("resultDataSplit", resultDataSplit, arraySearch, result_lastWork[i])
                //     // let ll = val.lastWork.concat(action.data);
                //     arraySearch.push(result_lastWork[i])
                //     result_lastWork[i].flagDate = true;
                //     //   val.lastWork.push(action.data)
                //
                // }
            }


            return result_lastWork;
        }

        return data;

    }

    getData(noLading) {
        let res_item = this.props.route.params.item;
        let {stateItemExtraFirst, stateItemExtra} = this.state;

        let paramss = {

            "_operation": typeExport._Shahrdar,
            'mode': typeExport._GetCsStatus,
            "token": store.getState().reducerSplashSatiaScreen.token,
            "customValue": stateItemExtra ? stateItemExtra.status : stateItemExtraFirst.status,
            "state_params": this.props.route.params,
            "Serial": stateItemExtra ? stateItemExtra.Serial : stateItemExtraFirst.Serial,
            "OpRef": stateItemExtra ? stateItemExtra.OpRef : stateItemExtraFirst.OpRef,
            "ReferTo": stateItemExtra ? stateItemExtra.ReferTo : stateItemExtraFirst.ReferTo,
            "Serial_resend": stateItemExtra ? stateItemExtra.Serial_resend : stateItemExtraFirst.Serial_resend,
            "lang": i18n.locale,

        };
        // this.props.callService(urlGetAllData, `?lang=${i18n.locale}&token=${token}&token_fb=${token_fb}`, TypeGetAllData, 'POST', token, token_fb, imageBack)
        this.props.callService(typeExport._baseUrlSatia + "operator_tk/readTask", paramss, typeExport.TypeGetDetailsTaskOperationSatiaScreen, typeExport._GET, store.getState().reducerSplashSatiaScreen.token, (data) => {
            //container.SetSateData("stateItemExtra", data)
            if (data){
                container.props.route.params.item["StatusName"] = data.StatusName;
                container.props.route.params.item["StatusColor"] = data.StatusColor;
                container.props.route.params.item["FinishTime"] = data.FinishTime;
            }
            this.setState({
                    stateItemExtra: data,
                    alaki: !this.state.alaki
                },
                () => {
                    //  this.goToIndex(lastWork && lastWork.length > 0 ? lastWork.length - 1 : 0)

                })
            // container.props.route.params.item = data;
            // container.props.route.params.itemExtra = data;


            /*  let obj = this.state.stateItemExtra;
              obj["StatusName"] = data.StatusName;
              this.setState({
                      stateItemExtra: obj,
                      alaki: !this.state.alaki
                  },
                  () => {
                      //  this.goToIndex(lastWork && lastWork.length > 0 ? lastWork.length - 1 : 0)

                  });*/

        }, noLading)
    }

    SetSateData(name, data) {
        container.setState({[name]: data})
    }


    /////////////////////////
    hiddenModal() {

        this.setState({
                visibleModal: '',
                sliderList: [],
            },
            () => {
                // Orientation.unlockAllOrientations();
                // Orientation.lockToPortrait();
            })
    }

    onShow(data) {
        this.setState({
            visibleModal: data,
            Modalcategory: true

        });
    }

    pauseVideo(index) {
        this.video.pause()
        if (this[`video${index}`]) {
            this[`video${index}`].pause()

            // let p = "paused" + index
            // this.setState({[p]: true})
            //  this.video.pauseAsync();
        }
    }

    playVideo = () => {
        if (this.video) {
            // this.video.playAsync();
            this.setState({paused: false})

        }
    }

    handlePlaying = (isVisible) => {

        isVisible ? this.playVideo() : this.pauseVideo();
    }
    onFullScreen = (value) => {
        // Set the params to pass in fullscreen status to navigationOptions
        this.props.navigation.setParams({
            fullscreen: !value
        })
        if (value) {
            // Orientation.lockToLandscape();
        } else {
            //  Orientation.unlockAllOrientations();
            //  Orientation.lockToPortrait();
        }
        this.setState({
            isFull: value
        })
    }

    async onFlyToPress(long, lat) {
        //await this.map.moveTo([ 49.66736778005486,34.08777640387088], 1000);
        /*      this.map.setCamera({
                  //  centerCoordinate: [49.66736778005486, 34.08777640387088],
                  centerCoordinate: [long, lat],
                  zoom: 16,
                  duration: 2000,
              })*/
        if (Platform.OS === "web") {
            //this.map.leafletElement.flyTo(c, 20, this.getZoomPanOptions())
            this.map.mapRef.current.flyTo([lat, long], 18)

        }
        else {
            const camera = await this.map.getCamera();

            camera.zoom = 17;
            camera.center.latitude = lat;
            camera.center.longitude = long;
            this.map.animateCamera(camera, {duration: 2000});
        }
        // this.onFlyToComplete();
    }

    centerMap(long, lat) {

        this.map.setCamera({
            //centerCoordinate: [typeExport.Longitude, typeExport.Latitude],
            centerCoordinate: [long, lat],
            zoom: 16,
            // duration: 2000,
            // mode: MapboxGL.CameraModes.Flight,
        });

    }

    componentWillReceiveProps(props) {

    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    componentDidUpdate(prevProps) {
    }

    async componentDidMount() {
        this.getData(true)
        //this.goToIndex(0);
        this.setState({
            // dataSourcearraycategory: this.state.arraycategory,
            // dataSourcearrayBedrooms: this.state.arrayBedrooms
        })


    }

    componentWillMount() {
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                const slideHeight = viewportHeight * 0.35;


                const sliderWidth = viewportWidth;

                container.setState({
                        widthOriginal: document.body.clientWidth,
                        widthV: document.body.clientWidth > 600 ? document.body.clientWidth / 2.05 : document.body.clientWidth,

                        //    widthV: document.body.clientWidth,
                        heightV: document.body.clientHeight,
                        // itemWidth: itemWidth,
                        sliderWidth: sliderWidth,
                        slideHeight: slideHeight,
                    },
                )


            })
        //  let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = this.state.stateItemExtraFirst;
        //   let checkVideo = files && files.length > 0 ? files.find(k => k.type === 'video/mp4') : false;
        //  let checkImage = files && files.length > 0 ? files.find(k => k.type === 'image/jpeg') : false;
        BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
    }

    componentWillUnmount() {


        if (Platform.OS === "web") {
        }
        else {

            BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);

            if (sound) {
                sound.release();
                sound = null;
            }
            if (this.timeout) {
                clearInterval(this.timeout);
            }
        }


    }

    nextTask(checkDone) {

        //global._refreshListTaskOperationSatia = true;
        let {item, type, indexExtra, itemExtra, pageDetails, itemExtraParent,} = container.props.route.params;
        let {listTask} = container.props;

        /*  if (listTask.length > indexExtra + 1) {
              console.log("@@@@@@", listTask[indexExtra + 1], indexExtra + 1)
              NavigationService.replace("DetailsTaskOperationSatiaScreen", {
                  item: listTask[indexExtra + 1],
                  itemExtra: listTask[indexExtra + 1],
                  itemExtraParent: itemExtraParent,
                  // type: type,
                  indexExtra: indexExtra + 1
              })
          }*/
        let indexRead = checkDone ? indexExtra + 1 : indexExtra;

        if (listTask.length >= indexRead + 1) {
            NavigationService.replace("DetailsTaskOperationSatiaScreen", {
                item: listTask[indexRead],
                itemExtra: listTask[indexRead],
                itemExtraParent: itemExtraParent,
                // type: type,
                indexExtra: indexRead
            })
            container.scrollView.scrollTo({
                y: 0,
                animated: true,
            });
        }
        else {
            NavigationService.Pop();
        }


    }

    handleBackButton = () => {

        if (this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectSlider') {
            this.setState({
                visibleModal: ''
            })
        } else {
            this.props.navigation.pop()
        }

        return true;
    };

    render() {

        let {setIndex, routes, index, slider1ActiveSlide, focusedAnim, listName} = this.state;
        let {user} = this.props;

        const url = 'https://your-url.com/video.mp4'
        const logo = 'https://your-url.com/logo.png'
        // const placeholder = 'https://your-url.com/placeholder.png'
        const titleVideo = 'My video title'

        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment, video, audio, image, subject, date, category, lastWork, messageid} = (this.state.stateItemExtra ? this.state.stateItemExtra : (this.state.stateItemExtraFirst ? this.state.stateItemExtraFirst : {}));
        let {item, type, indexExtra, pageDetails, itemExtraParent} = this.props.route.params;
        // let checkVideo = video ? video : (files && files.length > 0 && files.find(k => k.type === 'video/mp4') ? files.find(k => k.type === 'video/mp4').video : null);
        // let checkImage = image ? image : (files && files.length > 0 && files.find(k => k.type === 'image/jpeg') ? files.find(k => k.type === 'image/jpeg').image : null);

        // let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')).file)
        // let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')).file)
        // let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')).file)

        // let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')))
        // let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')))
        // let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')))

        let {results} = this.props;

        let listUser = results && results.listUser ? results.listUser : [];
        // let categoryTask = results && results.categoryTask ? results.categoryTask : [];
        // let categoryPriority = results && results.categoryPriority ? results.categoryPriority : [];


        return (
            <View style={{flex: 1,}}>
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>

                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>


                        <View
                            style={{flex: 1,}}>


                            <HMActionBarSatia
                                menu
                                props={this.props} statusBarTransparent
                                //   text={i18n.t('Privatizations.title')}
                                text={pageDetails ? "جزئیات بیشتر" : i18n.t('constant.Details')}
                                headerVisibility
                                more_menu
                                back
                                onBackPress={() => this.props.navigation.pop()}

                            />


                            <View style={{flex: 1,}}>
                                {/*<MaterialTabs*/}
                                {/*items={['وظیفه', i18n.t('constant.Information'), i18n.t('constant.MessageCirculation')]}*/}
                                {/*selectedIndex={this.state.index}*/}
                                {/*onChange={(i) => {*/}
                                {/*this.setState({index: i})*/}
                                {/*}}*/}
                                {/*barColor="#1fbcd2"*/}
                                {/*indicatorColor="#fffe94"*/}
                                {/*activeTextColor="white"*/}
                                {/*/>*/}


                                {

                                    <ScrollView
                                        ref={ref => {
                                            this.scrollView = ref
                                        }}
                                    >
                                        {this.renderDetails()}


                                        <View
                                            style={{
                                                width: "100%",
                                            }}>
                                            <View style={{

                                                flexDirection: 'row',
                                                ///  backgroundColor:'#a8ee7c',
                                                marginHorizontal: moderateScale(5),
                                                marginTop: moderateScale(8),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                alignSelf: 'center',
                                            }}>
                                                <HMTextView


                                                    type={"bold"}
                                                    noFont={!I18nManager.isRTL}
                                                    style={{
                                                        fontSize: moderateScale(12),
                                                        color: Colors.blackLight,
                                                        textAlign: 'center',
                                                        // marginTop: moderateScale(10)
                                                    }}
                                                    text={i18n.t('constant.MessageCirculation')}
                                                    //   text={"98/03/21"}
                                                />


                                            </View>


                                        </View>


                                        <HMFlatList

                                            // ItemSeparatorComponent={
                                            //     <View style={{
                                            //         width: '100%',
                                            //         height: moderateScale(1),
                                            //         backgroundColor: '#4f4f4f'
                                            //     }}/>
                                            // }
                                            // data={lastWork === null || !lastWork ? [] : lastWork}
                                            // extraData={lastWork}
                                            ref={(ref) => {
                                                //this.list = ref.flatListRef.current;
                                                this.list = ref && ref.flatListRef?.current;
                                            }}
                                            extraData={this.state}
                                            keyExtractor={(item, index) => index.toString() + (lastWork?.length)}

                                            data={lastWork === null || !lastWork ? [] : lastWork}
                                            // style={{transform: [{scaleY: -1}]}}
                                            // initialScrollIndex={1}
                                            renderItem={({item: itemLastWork, index: indexLastWork}) => {
                                                let {files, files_resend, CreatorTaskResend, color} = itemLastWork;
                                                //let checkType = (itemLastWork.type != "mine");
                                                //  let checkType = ((itemLastWork.OpRef_resend ? itemLastWork.OpRef_resend : itemLastWork.OpRef) == user.OpRef);
                                                let checkType = ((itemLastWork.OpRef_resend) != user.OpRef);
                                                // let resultDataSplit = this.state.arrayDate.find(obj => obj.date_split = itemLastWork.date_split);
                                                // let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')).file)
                                                // let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')).file)
                                                // let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')).file)
                                                //
                                                // let listVoice = [];
                                                // let listImage = [];
                                                // let listVideo = [];
                                                // let listOthers = [];
                                                // if (files)
                                                //     for (let i = 0; i < files.length; i++) {
                                                //         let f = String(files[i].type);
                                                //
                                                //         if (f.search('audio/') >= 0)
                                                //             listVoice.push(files[i])
                                                //
                                                //         else if (f.search('image/') >= 0)
                                                //             listImage.push(files[i])
                                                //
                                                //         else if (f.search('video/') >= 0)
                                                //             listVideo.push(files[i])
                                                //         else {
                                                //             listOthers.push(files[i])
                                                //         }
                                                //
                                                //     }

                                                // if (!this.state.arrayDate || this.state.arrayDate.length === 0) {
                                                //     //   dateFinal = itemLastWork.date_split;
                                                //     this.state.arrayDate.push(itemLastWork)
                                                // }
                                                // else if (!resultDataSplit) {
                                                //     //  dateFinal = itemLastWork.date_split;
                                                //     this.state.arrayDate.push(itemLastWork)
                                                // }

                                                return (
                                                    <View key={indexLastWork}
                                                          style={{
                                                              width: "100%",
                                                              //transform: [{scaleY: -1}]
                                                          }}
                                                    >

                                                        {
                                                            !itemLastWork.flagDate ?
                                                                null
                                                                :
                                                                <View
                                                                    style={{

                                                                        alignSelf: 'center',
                                                                        width: moderateScale(130),
                                                                        height: moderateScale(36),
                                                                        backgroundColor: Colors.blackLight,
                                                                        borderRadius: moderateScale(12),
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        marginTop: moderateScale(8)
                                                                    }}>

                                                                    <HMTextView

                                                                        type={"bold"}
                                                                        noFont={!I18nManager.isRTL}
                                                                        style={{
                                                                            fontSize: moderateScale(14),
                                                                            color: Colors.white,

                                                                            // marginTop: moderateScale(10)
                                                                        }}
                                                                        //text={'اراک خ هپکو خ امام حسین'}
                                                                        text={itemLastWork.Date_resend}
                                                                        //   text={"98/03/21"}
                                                                    />
                                                                </View>

                                                        }

                                                        <View
                                                            style={{
                                                                width: "94%",
                                                                backgroundColor: checkType ? Colors.white : "#effdde",
                                                                borderRadius: moderateScale(10),
                                                                marginVertical: moderateScale(4),
                                                                alignSelf: checkType ? "flex-end" : "flex-start",
                                                                // alignItems: checkType ? "flex-end" : "flex-start"

                                                            }}>
                                                            {/*         <HMTextView

                                                                    type={"bold"}
                                                                    noFont={!I18nManager.isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(18),
                                                                        color: Colors.blackLight,

                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    //text={'اراک خ هپکو خ امام حسین'}
                                                                    text={indexLastWork + ""}
                                                                    //   text={"98/03/21"}
                                                                />*/}
                                                            {
                                                                checkType ?
                                                                    <View
                                                                        style={{
                                                                            width: '100%',
                                                                            flexDirection: "row",
                                                                            // justifyContent: "flex-end",
                                                                            alignItems: "center",
                                                                            padding: moderateScale(4)
                                                                        }}>
                                                                        <View style={{
                                                                            width: moderateScale(48),
                                                                            height: moderateScale(48),
                                                                            borderRadius: moderateScale(24),
                                                                            borderColor: Colors.gray,
                                                                            borderWidth: moderateScale(1),
                                                                            overflow: "hidden"
                                                                        }}>
                                                                            <HMImageView
                                                                                _backgroundColorLoading={Colors.transparent}
                                                                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                uriComplete={CreatorTaskResend?.Image}
                                                                                // styleText={{marginTop: moderateScale(10)}}
                                                                                borderRadius={4}
                                                                            />
                                                                        </View>
                                                                        <HMTextView

                                                                            type={"bold"}
                                                                            noFont={!I18nManager.isRTL}
                                                                            style={{
                                                                                fontSize: moderateScale(13),
                                                                                color: itemLastWork.color ? Colors.white : Colors.colorDarkText,
                                                                                margin: moderateScale(6)

                                                                                // marginTop: moderateScale(10)
                                                                            }}
                                                                            text={(CreatorTaskResend && CreatorTaskResend.Name ? CreatorTaskResend.Name : "") + " - " + (CreatorTaskResend && CreatorTaskResend.operator ? CreatorTaskResend.operator : "")}
                                                                            styleRoot={[color && CreatorTaskResend && CreatorTaskResend.operator ? {
                                                                                borderRadius: moderateScale(16),
                                                                                backgroundColor: itemLastWork.color,
                                                                                marginHorizontal: moderateScale(4),
                                                                            } : {}]}
                                                                        />
                                                                        <HMTextView

                                                                            //  type={"bold"}
                                                                            noFont={!I18nManager.isRTL}
                                                                            style={{
                                                                                fontSize: moderateScale(12),
                                                                                color: itemLastWork.color ? itemLastWork.color : Colors.colorDarkText,
                                                                                margin: moderateScale(6)

                                                                                // marginTop: moderateScale(10)
                                                                            }}
                                                                            //   text={(itemLastWork.CreatorTaskResend && itemLastWork.CreatorTaskResend.operator ? itemLastWork.CreatorTaskResend.operator : "") + " - " + (itemLastWork.CreatorTaskResend && itemLastWork.CreatorTaskResend.Name ? itemLastWork.CreatorTaskResend.Name : "") + " در تاریخ : " + (itemLastWork.CreateTime_fa ? itemLastWork.CreateTime_fa : "")}
                                                                            text={" در تاریخ : " + (itemLastWork.CreateTime_fa ? itemLastWork.CreateTime_fa : "")}
                                                                        />


                                                                    </View>
                                                                    :
                                                                    null
                                                            }


                                                            {/*       <HMTextView

                                                                type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: Colors.colorDarkText,
                                                                    margin: moderateScale(6)

                                                                    // marginTop: moderateScale(10)
                                                                }}
                                                                text={itemLastWork.Title ? itemLastWork.Title : ""}
                                                            />
*/}

                                                            <HMTextView

                                                                type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: Colors.colorDarkText,
                                                                    margin: moderateScale(6)

                                                                    // marginTop: moderateScale(10)
                                                                }}
                                                                text={itemLastWork.Description_resend ? itemLastWork.Description_resend : ""}
                                                            />


                                                            {this.renderFiles(files_resend, indexLastWork)}


                                                            <HMTextView

                                                                // type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(12),
                                                                    color: Colors.colorDarkText,
                                                                    margin: moderateScale(6)

                                                                    // marginTop: moderateScale(10)
                                                                }}
                                                                text={itemLastWork.Date_resend_fa ? itemLastWork.Date_resend_fa : ""}
                                                                styleRoot={{
                                                                    width: "100%",
                                                                    flexDirection: "row",
                                                                    //  justifyContent: !checkType ? "flex-start" : "flex-end"
                                                                }}
                                                            />
                                                        </View>
                                                    </View>
                                                );

                                            }

                                            }

                                            onScroll={(event) => {
                                                const slideSize = event.nativeEvent.layoutMeasurement.height;
                                                const index = event.nativeEvent.contentOffset.y / slideSize;
                                                const roundIndex = Math.round(index);
                                                if (roundIndex === 0) {
                                                    this._toggle(true)
                                                }

                                                if (roundIndex === 1) {
                                                    this._toggle(false)
                                                }
                                            }
                                            }
                                            onScrollToIndexFailed={(error) => {
                                                //  alert("dfgf")
                                                this.list.scrollToOffset({
                                                    offset: error.averageItemLength * error.index,
                                                    animated: true
                                                });
                                                setTimeout(() => {
                                                    if (lastWork.length !== 0 && this.list !== null) {
                                                        this.list.scrollToIndex({
                                                            index: error.index,
                                                            animated: true
                                                        });
                                                    }
                                                }, 100);
                                            }}
                                            inverted
                                        />
                                        {!(itemExtraParent.type == 2 || itemExtraParent.type == 6) || (!this.props.token || (type === "report") || pageDetails) ?
                                            null
                                            :
                                            <HMBottomBarItemSatiaOperator
                                                ref={ref => (this.bottomBar = ref)}
                                                //FloatingActionButton
                                                listSelectInput={listUser}
                                                funcSwitch={() =>
                                                    // this.goToIndex(lastWork && lastWork.length > 0 ? lastWork.length - 1 : 0)
                                                    // this._toggle(false)
                                                    this.getData()
                                                }
                                                funcChangeState={(name, data) => {
                                                    this.setState({[name]: data})
                                                }}
                                                funcAddStateItemExtra={(data, response) => {


                                                    //   let obj = this.state.stateItemExtraFirst;
                                                    //    obj["lastWork"] = this.addFlagDate(data);
                                                    this.setState({
                                                            //stateItemExtraFirst: obj,
                                                            alaki: !this.state.alaki
                                                        },
                                                        () => {

                                                            // console.log("response@@@", response)
                                                            this.getData();
                                                        });


                                                }}
                                                // funcAlaki={()=>}
                                                itemExtraFirst={this.state.stateItemExtraFirst}
                                                itemExtra={this.state.stateItemExtra}
                                                resultsExtra={this.props.results}
                                                indexExtra={this.props.route.params.indexExtra}

                                                _setStateData={(data) => {
                                                    container.setState(data)
                                                }}
                                                //SelectInputRoll
                                                onValueChangeSelectInputRoll={(value) => {
                                                    let idx = listUser.findIndex(obj => obj.value == value);
                                                    let res = null;
                                                    if (idx !== -1) {
                                                        res = listUser[idx]
                                                    }

                                                    this.setState({
                                                        SelectRollValue: value,
                                                        Roll: res ? {
                                                            ...res,
                                                            index: idx
                                                        } : {
                                                            label: i18n.t('constant.SelectItem'),
                                                            value: idx,
                                                            index: idx
                                                        }
                                                    })
                                                }}
                                                valueSelectInputRoll={this.state.SelectRollValue ? "" : i18n.t('constant.SelectItem')}
                                                indexSelectInputRoll={this.state.Roll ? this.state.Roll.index : -1}
                                                itemSelectInputRoll={this.state.Roll}
                                                optionsSelectInputRoll={listUser ? listUser : []}
                                                showSelectInputRoll={this.state.showSelectInputRoll}
                                                //CCTask
                                                onValueChangeSelectInputCCTask={(value) => {
                                                    let idx = listUser.findIndex(obj => obj.value == value);
                                                    let idxListName = this.state.listName.findIndex(obj => obj.value == value);
                                                    let res = null;
                                                    var array = this.state.listName;
                                                    if (idx !== -1 && idxListName === -1) {
                                                        res = listUser[idx]
                                                        array = [...this.state.listName]; // make a separate copy of the array
                                                        array.push(res);
                                                    }
                                                    this.setState({
                                                        listName: array,
                                                        SelectCCTaskValue: value,
                                                        CCTask: res ? {
                                                            ...res,
                                                            index: idx
                                                        } : {
                                                            label: i18n.t('constant.SelectItem'),
                                                            value: idx,
                                                            index: idx
                                                        }
                                                    })
                                                }}

                                                valueSelectInputCCTask={this.state.SelectCCTaskValue ? "" : i18n.t('constant.SelectItem')}
                                                indexSelectInputCCTask={this.state.CCTask ? this.state.CCTask.index : -1}
                                                itemSelectInputCCTask={this.state.CCTask}
                                                optionsSelectInputCCTask={listUser ? listUser : []}
                                                listNameCCTask={listName ? listName : []}
                                                showSelectInputCCTask={this.state.showSelectInputCCTask}

                                                onPressListNameCCTask={() => {
                                                    return <TouchableOpacity
                                                        onPress={() => {
                                                            var array = [...this.state.listName]; // make a separate copy of the array

                                                            if (this.state.SelectCCTaskValue === this.state.listName[index].value) {
                                                                this.setState({
                                                                    SelectCCTaskValue: -1,
                                                                    CCTask: {
                                                                        label: i18n.t('constant.SelectItem'),
                                                                        value: -1,
                                                                        index: -1
                                                                    }
                                                                })
                                                            }
                                                            array.splice(index, 1);
                                                            this.setState({listName: array});


                                                            /*    let arr= this.state.listName
                                                                this.setState({
                                                                    listName: arr.splice(index, 1)
                                                                })*/
                                                        }}
                                                        style={{alignSelf: 'center'}}>
                                                        <HMIcon name={"md-close"} style={{
                                                            fontSize: moderateScale(14),
                                                            color: '#0f0f0f'
                                                        }}/>
                                                    </TouchableOpacity>
                                                }}

                                                funcNext={this.nextTask}
                                            />}
                                    </ScrollView>
                                }


                            </View>


                            {!this.state.largeMap ?
                                null
                                :
                                <View
                                    style={[{
                                        width: "100%",
                                        height: "100%",
                                        position: "absolute",
                                    }]}>
                                    {
                                        this.renderMap(latitude, longitude, true)
                                    }
                                    <TouchableOpacity
                                        style={{
                                            width: moderateScale(48),
                                            height: moderateScale(48),
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            padding: moderateScale(8),
                                            backgroundColor: Colors.red,
                                            borderRadius: moderateScale(24),
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                        onPress={() => {
                                            this.setState({largeMap: false})
                                        }}
                                    >
                                        <HMIcon name={"ios-close"}
                                                style={{color: Colors.white, fontSize: moderateScale(28)}}/>
                                    </TouchableOpacity>
                                </View>
                            }
                            <Popup
                                isVisible={this.state.isVisible}
                                onCancelPressed={() => this.setState({isVisible: false})}
                                onAppPressed={() => this.setState({isVisible: false})}
                                onBackButtonPressed={() => this.setState({isVisible: false})}
                                options={{
                                    latitude: latitude,
                                    longitude: longitude,
                                    // title: 'The White House',
                                    dialogTitle: i18n.t('constant.Routing'),
                                    dialogMessage: i18n.t('constant.SelectingDestination'),
                                    cancelText: i18n.t('constant.Back')
                                }}
                            />

                            {
                                this.state.visibleModal === 'selectSlider' || this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                                    <View
                                        style={{
                                            position: 'absolute',
                                            flex: 1,
                                            alignContent: 'center',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginTop: Platform.OS === 'ios' ? moderateScale(15) : 0,
                                            top: 0,
                                            bottom: 0,
                                            right: 0,
                                            left: 0,
                                            backgroundColor: 'rgba(0,0,0,0.7)',
                                            zIndex: 9900
                                        }}>
                                        <View
                                            style={{
                                                height: "100%",
                                                width: '100%',
                                                // padding: moderateScale(6),
                                                backgroundColor: Colors.black,
                                                position: 'relative'
                                            }}>
                                            {
                                                <View
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 0,
                                                        left: 0,
                                                        bottom: 0,
                                                    }}

                                                >
                                                    {/*<FlatList*/}
                                                    {/*ref={(ref) => { this.flatListRef = ref }}*/}
                                                    {/*data={[1,2,3,4,5]}*/}
                                                    {/*extraData={this.state}*/}
                                                    {/*//  onScroll={(e) => this.pauseAll(e)}*/}
                                                    {/*showsHorizontalScrollIndicator={false}*/}
                                                    {/*// scrollEnabled={this.state.isPortrait}*/}
                                                    {/*horizontal={true}*/}
                                                    {/*renderAheadOffset={0}*/}
                                                    {/*initialNumToRender={5}*/}
                                                    {/*windowSize={5}*/}
                                                    {/*removeClippedSubviews={true}*/}
                                                    {/*pagingEnabled={true}*/}
                                                    {/*keyExtractor={(item, id) => id.toString()}*/}
                                                    {/*renderItem={(item, index) => (this.renderFlatlist(item, index))}*/}
                                                    {/*/>*/}
                                                    <HMSwiper
                                                        list={this.state.sliderList}
                                                        renderItem={() =>
                                                            this.state.sliderList.map((item, index) => {
                                                                let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = (this.state.stateItemExtra ? this.state.stateItemExtra : (this.state.stateItemExtraFirst ? this.state.stateItemExtraFirst : {}));

                                                                return <View
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%'
                                                                    }}
                                                                >

                                                                    {
                                                                        this.state.visibleModal === 'selectSlider' ?
                                                                            <Image
                                                                                resizeMode={"contain"}
                                                                                style={{
                                                                                    flex: 1,
                                                                                }}
                                                                                // source={{uri: 'http://v1.qzone.cc/avatar/201407/07/00/24/53b9782c444ca987.jpg!200x200.jpg'}}
                                                                                source={{uri: item.file}}
                                                                            />
                                                                            :
                                                                            null
                                                                    }

                                                                    {
                                                                        this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                                                                            <HMVideo
                                                                                title={title}
                                                                                navigation={this.props.navigation}
                                                                                item={item} index={item.index}
                                                                                indexSelect={this.state.slider1ActiveSlide}
                                                                                //url={"http://techslides.com/demos/sample-videos/small.mp4"}
                                                                            />

                                                                            :
                                                                            null
                                                                    }


                                                                </View>

                                                            })
                                                        }
                                                    />
                                                    {/*          <Carousel page

                                                              ref={c => this._slider1Ref = c}
                                                              data={this.state.sliderList}
                                                        //    data={[1, 2, 3, 4, 5].}
                                                        //    data={this.state.entries}
                                                              renderItem={(item, index) => this.renderCarousel(item, index)


                                                              }
                                                        // inactiveSlideScale={.99}
                                                        // sliderWidth={sliderWidth}
                                                        // itemWidth={itemWidth}

                                                              inactiveSlideScale={1}
                                                        // sliderWidth={sliderWidth}
                                                        // itemWidth={itemWidth}

                                                              sliderWidth={Dimensions.get('window').width}
                                                              itemWidth={Dimensions.get('window').width}
                                                              hasParallaxImages={true}
                                                              firstItem={0}

                                                              inactiveSlideOpacity={0.7}
                                                        // inactiveSlideShift={20}
                                                              containerCustomStyle={styles_Carousel.slider}
                                                              contentContainerCustomStyle={styles_Carousel.sliderContentContainer}
                                                        // loop={true}
                                                        //loopClonesPerSide={1}
                                                        //    autoplay={true}
                                                        //   autoplayDelay={1000}
                                                        //   autoplayInterval={6000}
                                                              onSnapToItem={(index, item) => {
                                                                  //  alert("jvhcjk")
                                                                  //   this.pauseVideo(slider1ActiveSlide)
                                                                  // this[`video${slider1ActiveSlide}`].pause()

                                                                  // if( this.state.visibleModal === 'selectVideo' )
                                                                  // for (let i = 0; i <4 ; i++) {
                                                                  // }
                                                                  // this[`video0`].pause()
                                                                  // this[`video1`].pause()
                                                                  // this[`video2`].pause()
                                                                  // this[`video3`].pause()

                                                                  let p = "paused" + slider1ActiveSlide
                                                                  this.setState({
                                                                      [p]: true,
                                                                      slider1ActiveSlide: index
                                                                  }, () => {
                                                                  })
                                                              }
                                                              }
                                                              removeClippedSubviews={false}
                                                    />*/}
                                                </View>
                                            }
                                            {/*      <View
                                                style={{
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    width: typeExport._WIDTH,
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <Pagination
                                                    //  data={[1, 2, 3, 4, 5]}
                                                    dotsLength={this.state.sliderList.length}
                                                    activeDotIndex={slider1ActiveSlide}
                                                    containerStyle={styles.paginationContainer}
                                                    //  dotColor={'rgba(255, 255, 255, 0.92)'}
                                                    dotColor={Colors.colorSecondPrimary}
                                                    dotStyle={styles.paginationDot}
                                                    inactiveDotColor={Colors.white}
                                                    inactiveDotOpacity={0.4}
                                                    inactiveDotScale={0.6}
                                                    carouselRef={this._slider1Ref}
                                                    tappableDots={!!this._slider1Ref}
                                                />
                                            </View>*/}
                                        </View>
                                        <TouchableOpacity
                                            onPress={() => {
                                                this.hiddenModal()
                                            }}

                                            style={{
                                                width: moderateScale(32),
                                                height: moderateScale(32),
                                                // backgroundColor: '#ee005b',
                                                position: 'absolute',
                                                borderRadius: moderateScale(16),
                                                margin: moderateScale(4),
                                                top: 0,
                                                left: 0,
                                                alignItems: 'center',
                                                justifyContent: 'center',

                                            }}>
                                            <HMIcon name={"ios-close-circle-outline"} style={{
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(22)
                                            }}/>
                                        </TouchableOpacity>
                                    </View>
                                    :
                                    null
                            }
                            <HMModal
                                isVisible={this.state.visibleModal === 'selectListOthers'}
                                backdropColor={Colors.gray}
                                backdropOpacity={0.8}
                                animationIn="zoomInDown"
                                animationOut="zoomOutUp"
                                animationInTiming={600}
                                animationOutTiming={600}
                                backdropTransitionInTiming={600}
                                backdropTransitionOutTiming={600}
                                //style={{height: '60%'}}
                                onBackdropPress={() => this.hiddenModal()}
                                onBackButtonPress={() => this.hiddenModal()}
                            >

                                <View style={{
                                    //  height: "90%",
                                    padding: moderateScale(6),
                                    backgroundColor: Colors.white,
                                }}>
                                    <View style={{width: '100%', alignItems: 'center'}}>
                                        <HMTextView

                                            //type={"bold"}
                                            //   noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(11),
                                                color: Colors.colorPrimary,


                                                // marginTop: moderateScale(10)
                                            }}
                                            // text={item.status}
                                            text={i18n.t('constant.Files')}
                                            //   text={"98/03/21"}
                                        />
                                    </View>
                                    <HMFlatList

                                        data={this.state.sliderList}
                                        renderItem={({item, index}) =>
                                            <View style={{
                                                // width: "100%",
                                                flex: 1,
                                                marginHorizontal: moderateScale(10),
                                                //  marginVertical: moderateScale(2),
                                                // padding: moderateScale(6)
                                            }}>

                                                <TouchableOpacity
                                                    onPress={() => {
                                                        Tools.GoLink(item.file)
                                                    }}
                                                    style={{
                                                        //paddingVertical: moderateScale(10),
                                                        //  width: '100%',
                                                        alignItems: 'center',
                                                        flexDirection: 'row',
                                                        flex: 1,
                                                        padding: moderateScale(6)
                                                    }}
                                                >

                                                    <View


                                                        style={{
                                                            flex: .2
                                                            //   width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            // backgroundColor: '#ee005b',
                                                            //  position: 'absolute',
                                                            //   borderRadius: moderateScale(16),
                                                            //margin: moderateScale(4),
                                                            //   top: 0,
                                                            //   left: 0,

                                                            //  justifyContent: 'center',

                                                        }}>
                                                        <HMIcon name={"ios-attach"} style={{
                                                            textAlign: 'center',
                                                            //alignSelf: 'flex-end',
                                                            color: Colors.gray,
                                                            // width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            fontSize: moderateScale(22)
                                                        }}/>


                                                    </View>

                                                    <View style={{flex: .8}}>
                                                        <HMTextView

                                                            //type={"bold"}
                                                            //   noFont={!I18nManager.isRTL}
                                                            style={{
                                                                fontSize: moderateScale(11),
                                                                color: Colors.colorDark,

                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            // text={item.status}
                                                            text={item.file}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>

                                                </TouchableOpacity>

                                            </View>
                                        }
                                    />


                                </View>
                            </HMModal>


                            {
                                !this.state.largeMap ?
                                    <Animated.View
                                        style={{
                                            top: focusedAnim.interpolate({
                                                //  inputRange: [0, 0.5, 0.51, 0.7, 1],
                                                inputRange: [0, 0.5, 0.51, 0.7, 1],
                                                outputRange: [
                                                    moderateScale(-50),
                                                    moderateScale(0),
                                                    -0,
                                                    -0,
                                                    100,
                                                ],
                                            }),
                                        }}

                                    >
                                        <TouchableOpacity
                                            onPress={() => {
                                                this._toggle(true);
                                                if (Platform.OS === "ios")
                                                    this.list.scrollToIndex({index: 0, animated: true});
                                                else
                                                    this.list.scrollToEnd({animated: true});
                                                // this.setState({
                                                //     visibleModal: true
                                                // })
                                            }}
                                            style={{
                                                position: 'absolute',
                                                bottom: moderateScale(0),
                                                overflow: 'hidden',
                                                width: moderateScale(48),
                                                height: moderateScale(48),
                                                borderRadius: moderateScale(24),
                                                // padding: moderateScale(4),
                                                margin: moderateScale(5),
                                                borderWidth: moderateScale(1),
                                                borderColor: Colors.colorSecondPrimary,
                                                borderBottomWidth: 0,
                                                shadowColor: '#000',
                                                shadowOffset: {width: 0, height: moderateScale(.7)},
                                                shadowOpacity: 0.6,
                                                shadowRadius: moderateScale(2),
                                                elevation: moderateScale(1),
                                                // marginLeft: moderateScale(1),
                                                // marginRight: moderateScale(1),
                                                // marginTop: moderateScale(1),
                                                // marginBottom: moderateScale(1),
                                                backgroundColor: Colors.colorSecondPrimary,
                                                alignItems: 'center',
                                                justifyContent: "center"
                                            }}

                                        >
                                            <HMIcon name="chevron-down" style={{
                                                color: Colors.white,
                                                fontSize: moderateScale(28),
                                                //  padding: moderateScale(4),
                                                alignSelf: "center",
                                            }}/>
                                        </TouchableOpacity>
                                    </Animated.View>
                                    :
                                    null
                            }

                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize
                                        onPress={() => this.getData()}
                                    />
                                    :
                                    null
                            }
                            {
                              //  this.props.isLoading || this.state.isLoadingSet ?
                                this.state.isLoadingSet ?
                                    <DialogLoadingCustomize
                                    />
                                    :
                                    null
                            }


                        </View>


                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderMap(latitude, longitude, type) {
        // return null;
        return <HMMap


            ref={ref => (this.map = ref)}
            styleMap={this.state.largeMap ? {

                width: "100%",
                height: "100%",
            } : {
                width: moderateScale(100),
                height: moderateScale(80),
            }}
            style={[{
                width: "100%",
                //height:height-moderateScale(200),
                height: "100%",
                marginBottom: this.state.marginBottom
            },
                // !type?{bottom: -25}:{}
            ]}
            showPlace
            initialRegion={{
                latitude: parseFloat(latitude),
                longitude: parseFloat(longitude),
                latitudeDelta: type ? 0.0015 : 0.0035,
                longitudeDelta: type ? 0.00121 : 0.00321,
            }}
            coordinate={{
                latitude: parseFloat(latitude),
                longitude: parseFloat(longitude),
                latitudeDelta: type ? 0.0015 : 0.0035,
                longitudeDelta: type ? 0.00121 : 0.00321,
            }}
            zoom={type ? 20 : 14.7}
            typeMap={!type}
            //application
            pitchEnabled={type}

            rotateEnabled={type}

            scrollEnabled={type}

            zoomEnabled={type}

            //web
            zoomControl={type}
            doubleClickZoom={type}
            closePopupOnClick={type}
            dragging={type}
            zoomSnap={type}
            zoomDelta={type}
            trackResize={type}
            touchZoom={type}
            scrollWheelZoom={type}

            showWrap={true}

            attributionControl={type}
        >

        </HMMap>
    }


    renderFiles(files, indexParent) {
        return <View
            style={{
                //position:'absolute',
                flexDirection: "row",
                flexWrap: 'wrap',
                flex: 1,

                flexGrow: 1,
                alignItems: "center",
                //  alignItems: 'center', justifyContent: 'center',
                //  backgroundColor: _main ? "#eee" : Colors.transparent,
                //  backgroundColor: "#876a79",
            }}>


            {
                files && files.length > 0 ?
                    (files).map((item, key) => {
                        //let f = String(files[key].type);
                        let f = String(item.type);
                        if (f.search('audio/') >= 0)

                            return <HMVoicePlayer key={key} index={indexParent}
                                                  SeekBarCheck={true}
                                                  indexSelect={this.state.indexSelectVoice}
                                                  audioRefExtra={this.state.audioRefExtra}
                                                  itemExtra={item}
                                                  duration={item.duration}
                                                  path={item.file} onPress={(func, audioRef) => {
                                this.setState({
                                    indexSelectVoice: indexParent,
                                    audioRefExtra: audioRef
                                }, () => {
                                    func ? func() : null
                                })
                            }}/>


                        else if (f.search('image/') >= 0)
                            return <TouchableOpacity
                                key={key + "_" + indexParent}
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectSlider",
                                        sliderList: [item],
                                        slider1ActiveSlide: 0
                                    })
                                }}
                            >
                                <HMImageView
                                    resizeMode={'cover'}
                                    uriComplete={item.file}
                                    _backgroundColorLoading={Colors.black}
                                    styleImage={{
                                        //  resizeMode: 'cover',
                                        width: "100%",
                                        height: "100%",
                                        //   backgroundColor: "#ee7e0c",
                                        //  borderTopRightRadius:moderateScale(8),
                                        //  borderTopEndRadius: moderateScale(12),
                                        //  borderTopStartRadius: moderateScale(8),
                                    }}
                                    //  onLoad={this._onLoad}
                                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                                />
                            </TouchableOpacity>
                        else if (f.search('video/') >= 0)
                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectVideo",
                                        // pathVideo: checkVideo,
                                        sliderList: [item],

                                        slider1ActiveSlide: 0
                                    })
                                }}
                            >


                                <View


                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderRadius: moderateScale(2),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {
                                            width: 0,
                                            height: moderateScale(.8)
                                        },
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        marginLeft: moderateScale(1),
                                        marginRight: moderateScale(1),
                                        marginTop: moderateScale(1),
                                        marginBottom: moderateScale(1),
                                        backgroundColor: Colors.blackLight,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>


                                    <View

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            paddingVertical: moderateScale(10),
                                            //backgroundColor: '#96a7ee',
                                            //  width: moderateScale(40),
                                            //height: moderateScale(40),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <HMIcon
                                            name={"play"}
                                            style={{
                                                //  width: moderateScale(40),
                                                // height: moderateScale(40),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(26)
                                            }}/>

                                    </View>


                                </View>
                            </TouchableOpacity>

                        else {


                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectListOthers",
                                        sliderList: [item],
                                        slider1ActiveSlide: 0,
                                        // visibleModal: "selectaudio",
                                        // pathAudio: checkAudio,
                                    })
                                }}
                            >


                                <View


                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderRadius: moderateScale(2),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {
                                            width: 0,
                                            height: moderateScale(.8)
                                        },
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        marginLeft: moderateScale(1),
                                        marginRight: moderateScale(1),
                                        marginTop: moderateScale(1),
                                        marginBottom: moderateScale(1),
                                        backgroundColor: Colors.blackLight,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>


                                    <View

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            paddingVertical: moderateScale(10),
                                            //backgroundColor: '#96a7ee',
                                            //  width: moderateScale(40),
                                            //height: moderateScale(40),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <HMIcon
                                            name={"attach"}
                                            style={{
                                                //  width: moderateScale(40),
                                                // height: moderateScale(40),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(26)
                                            }}/>

                                    </View>


                                </View>
                            </TouchableOpacity>
                        }


                    })
                    :
                    null
            }

        </View>
    }

    renderDetails() {
        let {Title, Serial, Name, CreateTime_fa, Source, PriorityName, StatusName, PriorityColor, StatusColor, CreatorTask, ReferToTask, ReadTime_fa, WorkTime, FinishTime_fa, Description, StringNamesCcTo, OpRef, ReferTo, files} = (this.state.stateItemExtra ? this.state.stateItemExtra : (this.state.stateItemExtraFirst ? this.state.stateItemExtraFirst : {}));
        let {item, type, indexExtra, pageDetails} = this.props.route.params;
        item = item ? item : {};
        //   return null;
        return <View style={{width: "100%",}}>

            <View
                style={{
                    width: "100%",
                    padding: moderateScale(2),
                    marginVertical: moderateScale(4)
                }}>
                <View
                    style={[{
                        width: "100%",

                        borderWidth: moderateScale(1),
                        borderColor: "#814646",
                        borderRadius: moderateScale(6),
                        padding: moderateScale(4),
                        overflow: "hidden",
                        marginTop: moderateScale(28)

                    },
                        //   !this.state.more ? {height: moderateScale(200),} : {}
                    ]}>


                    <View
                        style={{
                            width: "100%",
                            // display: this.state.more? null : "none"
                            // display: pageDetails ? null : "none"
                        }}
                    >

                        <HMTextView type={"bold"}
                            //   text={i18n.t('constant.signIn')}
                                    text={type === "report" ? "اطلاعات" : i18n.t('constant.Task')}
                                    styleRoot={{
                                        alignSelf: 'center',
                                        marginHorizontal: moderateScale(10),
                                        marginTop: moderateScale(4)
                                    }}
                                    style={{
                                        color: Colors.blackLight,
                                        fontSize: moderateScale(13),


                                        //marginEnd: moderateScale(10)
                                    }}/>
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.TaskTitle')}
                            title={Title}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={"توضیحات"}
                            title={Description ? Description.trim() : " - "}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.TaskType')}
                            title={Name}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={"شماره وظیفه"}
                            title={Serial}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4),}}
                            styleTitle={{color: PriorityColor ? PriorityColor : Colors.colorDark}}

                            //  text={i18n.t('constant.MessageGroup')}
                            text={"الویت"}
                            title={PriorityName}


                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />


                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            styleTitle={{color: StatusColor ? StatusColor : Colors.colorDark}}
                            text={i18n.t('constant.Status')}
                            title={StatusName}
                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={"مشترک"}
                            title={CreatorTask.Mobile}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />


                        <View style={{width: "100%"}}>

                            <HMListItemTitle
                                backgroundColorTitle={Colors.gray}

                                // title={"معرفی دوستان"}
                                styleRoot={{marginTop: moderateScale(4)}}
                                text={"ثبت توسط"}
                                title={(CreatorTask ? (`${CreatorTask.operator} (${CreatorTask.Name})`) : "") + ("  تاریخ ثبت : " + (CreateTime_fa ? CreateTime_fa : ""))}

                                //   image={require("../../assets/img/add-friend.png")}
                                image={"md-clipboard"}
                                NoShowIconOnpress
                                onPress={() => {
                                    //   this.onShare()
                                }}
                            />
                            <HMListItemTitle
                                backgroundColorTitle={Colors.gray}

                                // title={"معرفی دوستان"}
                                styleRoot={{marginTop: moderateScale(4)}}
                                text={i18n.t('constant.TaskReference')}
                                title={(ReferToTask ? (`${ReferToTask.operator} (${ReferToTask.Name})`) : "")}

                                //   image={require("../../assets/img/add-friend.png")}
                                image={"md-clipboard"}
                                NoShowIconOnpress
                                onPress={() => {
                                    //   this.onShare()
                                }}
                            />
                            <HMListItemTitle
                                backgroundColorTitle={Colors.gray}

                                // title={"معرفی دوستان"}
                                styleRoot={{marginTop: moderateScale(4)}}
                                text={"تاریخ مشاهده وظیفه"}
                                title={ReadTime_fa ? ReadTime_fa : " - "}

                                //   image={require("../../assets/img/add-friend.png")}
                                image={"md-clipboard"}
                                NoShowIconOnpress
                                onPress={() => {
                                    //   this.onShare()
                                }}
                            />
                            <HMListItemTitle
                                backgroundColorTitle={Colors.gray}

                                // title={"معرفی دوستان"}
                                styleRoot={{marginTop: moderateScale(4)}}
                                text={"مهلت انجام کار"}
                                title={WorkTime ? WorkTime : " - "}

                                //   image={require("../../assets/img/add-friend.png")}
                                image={"md-clipboard"}
                                NoShowIconOnpress
                                onPress={() => {
                                    //   this.onShare()
                                }}
                            />


                            <HMListItemTitle
                                backgroundColorTitle={Colors.gray}

                                // title={"معرفی دوستان"}
                                styleRoot={{marginTop: moderateScale(4)}}
                                text={i18n.t('constant.EndTask')}
                                title={FinishTime_fa ? FinishTime_fa : " - "}

                                //   image={require("../../assets/img/add-friend.png")}
                                image={"md-clipboard"}
                                NoShowIconOnpress
                                onPress={() => {
                                    //   this.onShare()
                                }}
                            />


                        </View>


                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.SourceTaskCreation')}
                            title={Source}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />


                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={"رونوشت به"}
                            title={StringNamesCcTo}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={"افرادی که به این وظیفه دسترسی دارند"}
                            title={CreatorTask.Name + ((OpRef != ReferTo) ? ReferToTask.Name : "") + ", " + StringNamesCcTo}


                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />

                        <View style={{
                            backgroundColor: Colors.white,
                            borderRadius: moderateScale(8),
                            margin: moderateScale(moderateScale(4))
                        }}>
                            {this.renderFiles(files)}
                        </View>
                        {/*

                                                    <HMListItemTitle
                                                        backgroundColorTitle={Colors.gray}
                                                        text={i18n.t('constant.Image')}
                                                        title={this.state.listImage.length > 0 ? i18n.t('constant.View') : null}
                                                        file={"aaaa"}
                                                        path={this.state.listImage.length > 0 ? this.state.listImage : null}
                                                        //   image={require("../../assets/img/add-friend.png")}
                                                        image={"md-image"}
                                                        styleRoot={{marginTop: moderateScale(4)}}

                                                        NoShowIconOnpress
                                                        onPress={() => {
                                                            //   this.onShare()
                                                        }}
                                                        onPressChild={
                                                            () => this.setState({
                                                                visibleModal: "selectSlider",
                                                                // pathVideo: checkVideo
                                                                sliderList: this.state.listImage
                                                            })
                                                        }
                                                    />
                                                    <HMListItemTitle
                                                        backgroundColorTitle={Colors.gray}
                                                        text={i18n.t('constant.Video')}
                                                        title={this.state.listVideo.length > 0 ? i18n.t('constant.View') : null}
                                                        file={"video"}
                                                        //  path={checkImage ? checkImage : null}
                                                        //   image={require("../../assets/img/add-friend.png")}
                                                        image={"md-image"}
                                                        styleRoot={{marginTop: moderateScale(4)}}
                                                        onPressChild={
                                                            () => this.setState({
                                                                visibleModal: "selectVideo",
                                                                //  pathVideo: checkVideo,
                                                                sliderList: this.state.listVideo,
                                                                slider1ActiveSlide: 0

                                                            })
                                                        }
                                                        NoShowIconOnpress
                                                        onPress={() => {
                                                            //   this.onShare()
                                                        }}
                                                    />
                                                    <HMListItemTitle
                                                        backgroundColorTitle={Colors.gray}
                                                        text={i18n.t('constant.Voice')}
                                                        title={this.state.listVoice.length > 0 ? i18n.t('constant.View') : null}
                                                        file={"video"}
                                                        path={this.state.listVoice.length > 0 ? this.state.listVoice : null}
                                                        //   image={require("../../assets/img/add-friend.png")}
                                                        image={"md-image"}
                                                        styleRoot={{marginTop: moderateScale(4)}}
                                                        onPressChild={
                                                            () => this.setState({
                                                                visibleModal: "selectaudio",
                                                                //  pathVideo: checkAudio,
                                                                sliderList: this.state.listVoice,

                                                                slider1ActiveSlide: 0
                                                                // visibleModal: "selectaudio",
                                                                // pathAudio: checkAudio
                                                            }, () => {
                                                            })
                                                        }
                                                        NoShowIconOnpress
                                                        onPress={() => {
                                                            //   this.onShare()
                                                        }}
                                                    />
                                                    <HMListItemTitle
                                                        backgroundColorTitle={Colors.gray}
                                                        text={i18n.t('constant.Files')}
                                                        title={this.state.listOthers.length > 0 ? i18n.t('constant.View') : null}
                                                        file={"others"}
                                                        path={this.state.listOthers.length > 0 ? this.state.listOthers : null}
                                                        //   image={require("../../assets/img/add-friend.png")}
                                                        image={"md-image"}
                                                        styleRoot={{marginTop: moderateScale(4)}}
                                                        onPressChild={
                                                            () => this.setState({
                                                                visibleModal: "selectSlider",
                                                                //  pathVideo: checkAudio,
                                                                sliderList: this.state.listOthers,

                                                                slider1ActiveSlide: 0
                                                                // visibleModal: "selectaudio",
                                                                // pathAudio: checkAudio
                                                            })
                                                        }
                                                        NoShowIconOnpress
                                                        onPress={() => {
                                                            //   this.onShare()
                                                        }}
                                                    />*/}
                    </View>
                    <View
                        style={{
                            width: "100%",
                            //    position: "absolute",
                            //   bottom: 0,
                            alignSelf: 'center',
                            flexDirection: "row",
                            justifyContent: "space-between",
                            paddingHorizontal: moderateScale(4),
                            marginTop: moderateScale(6)
                        }}>
                        <HMTextView
                            type={"bold"}
                            text={CreateTime_fa}
                            styleRoot={{
                                alignSelf: 'center',
                                marginHorizontal: moderateScale(10),
                                marginTop: moderateScale(4)
                            }}
                            style={{
                                color: Colors.colorDark,
                                fontSize: moderateScale(13),


                                //marginEnd: moderateScale(10)
                            }}/>
                        {
                            // pageDetails ?
                            //     null
                            //     :
                            //     <TouchableOpacity
                            //         onPress={() => {
                            //
                            //             NavigationService.navigateKeyDynamic("DetailsTaskOperationSatiaScreen", {
                            //                 item: item,
                            //                 type: type,
                            //                 indexExtra: indexExtra,
                            //                 pageDetails: true
                            //             })
                            //             // this.setState({
                            //             //     more: !this.state.more
                            //             // })
                            //         }}
                            //     >
                            //         <HMTextView
                            //             type={"bold"}
                            //             text={this.state.more ? "کمتر" : "بیشتر"}
                            //             styleRoot={{
                            //                 alignSelf: 'center',
                            //                 marginHorizontal: moderateScale(10),
                            //                 marginTop: moderateScale(4)
                            //             }}
                            //             style={{
                            //                 color: Colors.blue,
                            //                 fontSize: moderateScale(13),
                            //
                            //
                            //                 //marginEnd: moderateScale(10)
                            //             }}/>
                            //     </TouchableOpacity>
                        }

                    </View>
                </View>

                <View
                    style={[{
                        position: "absolute",
                        top: 0,
                        alignSelf: 'center',
                        width: moderateScale(130),
                        height: moderateScale(36),
                        backgroundColor: Colors.blackLight,
                        borderRadius: moderateScale(12),
                        justifyContent: 'center',
                        alignItems: 'center',
                    }]}>
                    <HMTextView

                        type={"bold"}
                        noFont={!I18nManager.isRTL}
                        style={{
                            fontSize: moderateScale(14),
                            color: Colors.white,

                            // marginTop: moderateScale(10)
                        }}
                        //text={'اراک خ هپکو خ امام حسین'}
                        text={item.CreateTime_fa}
                        //   text={"98/03/21"}
                    />
                </View>

            </View>
            {/*

                                        {
                                            latitude && latitude != null && latitude != '' ?
                                                <HMDetailsMap
                                                    position={{latitude: latitude, longitude: longitude}}/>
                                                : null
                                        }
*/}


            {
                // latitude && latitude != null && latitude != '' ?
                //     <View>
                //         <View
                //             onPress={() => {
                //             }
                //                 /*  NavigationService.navigateParams("MapShowScreen", {
                //                    //   latitude: data.latitude, longitude: data.longitude
                //                   })*/
                //             } style={{
                //             width: "100%",
                //             //height: moderateScale(200)
                //             height: (this.state.widthOriginal > 600) ? 430 : (Platform.OS === "web" ? this.state.widthOriginal : typeExport.WIDTH) / 1.6
                //
                //         }}>
                //             <HMMap
                //                 ref={ref => (this.map = ref)}
                //                 style={{
                //                     width: "100%",
                //                     //height:height-moderateScale(200),
                //                     height: "100%",
                //                     marginBottom: this.state.marginBottom
                //                 }}
                //                 showPlace
                //                 initialRegion={{
                //                     latitude: parseFloat(latitude),
                //                     longitude: parseFloat(longitude),
                //                     latitudeDelta: 0.015,
                //                     longitudeDelta: 0.0121,
                //                 }}
                //                 coordinate={{
                //                     latitude: parseFloat(latitude),
                //                     longitude: parseFloat(longitude),
                //                     latitudeDelta: 0.015,
                //                     longitudeDelta: 0.0121,
                //                 }}
                //
                //             >
                //                 {/*   <MapView.Marker coordinate={{
                //                     latitude: parseFloat(latitude),
                //                     longitude: parseFloat(longitude),
                //                     latitudeDelta: 0.015,
                //                     longitudeDelta: 0.0121,
                //                 }}/>*/}
                //
                //             </HMMap>
                //
                //             {
                //                 // address ?
                //                 1 === 1 ?
                //                     <TouchableOpacity
                //                         onPress={() => this.onFlyToPress(parseFloat(longitude), parseFloat(latitude))}
                //                         style={{
                //                             flexDirection: "row",
                //                             padding: moderateScale(5),
                //                             //     justifyContent: "flex-end",
                //                             alignItems: "center",
                //                             width: "100%",
                //                             backgroundColor: "rgba(0, 0, 0, 0.4)",
                //                             position: "absolute",
                //                             bottom: 0,
                //                             left: 0
                //                         }}>
                //                         <HMIcon type={"Feather"}                                                 name={"map-pin"}
                //                                 style={{
                //                                     marginEnd: moderateScale(10),
                //                                     fontSize: moderateScale(22),
                //                                     color: Colors.white
                //                                 }}/>
                //                         <HMTextView
                //
                //                             type={"bold"}
                //                             noFont={!I18nManager.isRTL}
                //                             style={{
                //                                 fontSize: moderateScale(12),
                //                                 color: Colors.light3,
                //
                //                                 // marginTop: moderateScale(10)
                //                             }}
                //                             //text={'اراک خ هپکو خ امام حسین'}
                //                             text={address}
                //                             //   text={"98/03/21"}
                //                         />
                //
                //                     </TouchableOpacity>
                //                     :
                //                     null
                //             }
                //
                //             <TouchableOpacity
                //
                //                 onPress={() => {
                //                     Platform.OS === 'android' ?
                //                         Tools.GoLink(`geo:${latitude},${longitude}`)
                //                         : this.setState({
                //                             /*   lat: this.state.regionFeature ? this.state.regionFeature.geometry.coordinates[1] : this.state.lat,
                //                                long: this.state.regionFeature ? this.state.regionFeature.geometry.coordinates[0] : this.state.long, */
                //
                //                             lat: latitude,
                //                             long: longitude,
                //                             isVisible: true
                //                         })
                //                 }}
                //                 style={{
                //                     position: 'absolute',
                //                     margin: moderateScale(4),
                //                     alignItems: 'center',
                //                     justifyContent: 'center',
                //                     top: 0,
                //                     left: 0,
                //                     height: moderateScale(38),
                //                     width: moderateScale(38),
                //                     borderRadius: moderateScale(19),
                //                     backgroundColor: Colors.colorPrimary
                //                 }}>
                //                 <HMIcon
                //                     name={"location"}
                //                     type="Entypo"
                //                     style={{
                //                         fontSize: moderateScale(20),
                //                         color: Colors.white,
                //                         textAlign: "center",
                //                         padding: moderateScale(4),
                //
                //                     }}/>
                //
                //             </TouchableOpacity>
                //
                //         </View>
                //         <HMDetailsMap
                //             position={{latitude: latitude, longitude: longitude}}/>
                //
                //     </View>
                //     : null
            }

            {
                // !this.props.token || (type === "report") ?
                //     null
                //     :
                //     <TouchableOpacity
                //         style={{
                //             backgroundColor: Colors.colorPrimary,
                //             width: "96%",
                //             height: moderateScale(40),
                //             alignSelf: 'center',
                //             alignItems: "center",
                //             justifyContent: "center",
                //             marginTop: moderateScale(8),
                //             borderRadius: moderateScale(6)
                //             // borderRadius:moderateScale(2)
                //         }}
                //         onPress={() => {
                //             this.getData()
                //
                //         }}
                //     >
                //         <View style={{
                //             flexDirection: "row",
                //             alignItems: "center",
                //             justifyContent: "center"
                //         }}>
                //             <HMTextView type={"bold"}
                //                 //   text={i18n.t('constant.signIn')}
                //                         text={i18n.t('constant.Switching')}
                //
                //                         style={{
                //                             color: "white",
                //                             fontSize: moderateScale(13),
                //                             //marginEnd: moderateScale(10)
                //                         }}/>
                //
                //         </View>
                //     </TouchableOpacity>

            }


        </View>
    }

    goToIndex(index) {
        // let {lastWork, messageid} = container.state.stateItemExtraFirst
        if (container.list && index >= 0)
            setTimeout(function () {


                try {
                    container.scrollView.scrollToEnd({animated: true})
                    // container.list.scrollToIndex({animated: true, index: index});

                } catch (e) {
                    console.error(e)
                }

            }, 100)

    }

    _toggle(isActive) {
        //  const {animationDuration, easing, useNativeDriver} = this.props;
        //this.isActive = isActive;
        Animated.timing(this.state.focusedAnim, {
            toValue: isActive ? 1 : 0,
            // toValue: 1,
            duration: 300,
            //  easing,
            // useNativeDriver,
        }).start();
    }


}

const styles = StyleSheet.create({
    /* container: {
         marginVertical: 5,
         borderRadius: 4,
         borderStyle: 'solid',
         borderWidth: 2,
         borderColor: Colors.green,
         backgroundColor: Colors.white,
         flex: 0,
         height: 'auto',
         overflow: 'hidden'
     },*/
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    contain: {
        flex: 1,
        height: 150,
        width: "100%",
        // height: "100%",
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },


    container: {
        paddingHorizontal: BASE_PADDING,
    },
    closeButton: {
        color: 'white',
        borderWidth: 1,
        borderColor: 'white',
        padding: 8,
        borderRadius: 3,
        textAlign: 'center',
        margin: 10,
        alignSelf: 'flex-end',
    },
    customHeaderBox: {
        height: 150,
        backgroundColor: '#6C7A89',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
        marginLeft: -BASE_PADDING,
        marginRight: -BASE_PADDING,
    },
    col: {
        flex: 1,
    },
    square: {
        //  width: WINDOW_WIDTH ,
        // height: WINDOW_WIDTH ,
        justifyContent: 'center',
        alignSelf: 'center',
    },
    squareFirst: {
        backgroundColor: '#C0392B',
    },
    squareSecond: {
        backgroundColor: '#019875',
    },
    squareText: {
        textAlign: 'center',
        color: 'white',
    },
    carousel: {
        height: WINDOW_WIDTH - BASE_PADDING * 2,
        width: WINDOW_WIDTH - BASE_PADDING * 2,
        backgroundColor: 'white',
    },
    text: {
        marginVertical: BASE_PADDING * 2,
    },
    /* size: {
         input: moderateScale(100),
         icon: 20
     }*/
});

